import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

const QueryStudioProductStatusFlowReport = (params?: Record<string, unknown>) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.StudioProductStatusFlowReportQueryURL
            .QueryStudioProductStatusFlowReport,
        method: RequestType.GET,
        params,
    });

export const StudioProductStatusFlowReportQuery = {
    QueryStudioProductStatusFlowReport,
};
